export default "__VITE_ASSET__BrM5jv7o__"